import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import Select, { SelectOption } from '../../shared/Select/index.jsx';
import TextInput from '../../shared/TextInput/index.jsx';
import { BackArrow } from '../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333333;
  }
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const SplitInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 48%;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const Subscript = styled.p`
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  width: 100%;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const years = [
  '',
  ...Array.from({ length: new Date().getFullYear() - 2013 + 1 }, (_, i) => `${new Date().getFullYear() - i}`).reverse(),
];
const days = Array.from({ length: 31 }, (_, i) => i + 1);

const Step7 = ({ incrementStep, decrementStep, formData }) => {
  const validateForm = () => {
    if (formData.installDateDay && formData.installDateYear && formData.installDateYear.length == 4) {
      const roofing_date = new Date(formData.installDateYear, formData.installDateMonth - 1, formData.installDateDay);
      const todays_date = new Date();
      todays_date.setHours(0, 0, 0, 0);
      console.log(todays_date);
      if (roofing_date <= todays_date) {
        return true;
      }
    }
    return false;
  };

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 7 - when was the roof installed"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>
          {formData.registrantType === 'homeowner'
            ? 'Is this also your mailing address?'
            : 'Is this also the mailing address for the homeowner?'}
        </BackText>
      </BackWrapper>
      <p>Next, we’re going to ask a few questions about the installation of the roof.</p>
      <Header>When was the roof installed?</Header>
      <SplitInputContainer>
        <Select
          fieldKey="installDateMonth"
          options={months.map((month, index) => (
            <SelectOption key={month} value={index + 1} text={month} />
          ))}
          htmlAttributes={{
            placeholder: 'Month',
          }}
        />
        <Select
          fieldKey="installDateDay"
          options={days.map((day, index) => (
            <SelectOption key={day} value={index + 1} text={day} />
          ))}
          htmlAttributes={{
            placeholder: 'Day',
          }}
        />
      </SplitInputContainer>
      <InputWrapper>
        <Select
          fieldKey="installDateYear"
          options={years.map((year, index) => (
            <SelectOption key={index} value={year} text={year} />
          ))}
          htmlAttributes={{
            placeholder: 'Year',
          }}
        />
      </InputWrapper>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 7 - when was the roof installed"
        onClick={incrementStep}
        disabled={!validateForm()}
      >
        Next
      </NextButton>

      <Subscript>If roof install year is not listed please call 1-800-ROOFING to proceed.</Subscript>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step7);
